import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { useState } from "react";
const PaymentMethod = ({ value, onChange }) => {
  const [method, setMethod] = useState(value);

  const handleOnChange = (e, value) => {
    setMethod((prev) => {
      if (onChange) {
        onChange(value);
      }
      return value;
    });
  };
  return (
    <Stack m={1}>
      <RadioGroup
        value={method}
        onChange={handleOnChange}
        name="paymentTypeOption"
      >
        <FormControlLabel
          label="Credit/Debit"
          value="0"
          control={<Radio style={{ padding: 0 }} />}
        />
        <FormControlLabel
          label="ACH"
          value="1"
          control={<Radio style={{ padding: 0 }} />}
        />
      </RadioGroup>
    </Stack>
  );
};

export default PaymentMethod;
